import { useResourceStorageKeys } from "src/framework/useResourceStorageKeys.tsx";
import { useMemo } from "react";
import { useStorageState } from "src/hooks/use-storage-state.ts";
import { memoryStorageDriver } from "src/storage/memoryStorage.driver.ts";

export const useResourceFormLangInternal = ({
  defaultLocale,
  resource,
  id,
  action,
  tab,
  requestParams,
  meta,
}: {
  resource: string;
  action: "edit" | "create";
  requestParams?: Record<string, any>;
  meta?: any;
  tab?: string;
  id: string | undefined;
  defaultLocale: string;
}) => {
  const storageKeys = useResourceStorageKeys({ resource });
  const langStorageKey = useMemo(
    () =>
      storageKeys.formLang({
        id: id!,
        type: action,
        tab,
        requestParams,
        meta,
      }),
    [storageKeys, id, action, requestParams, meta, tab],
  );

  const [lang, setLang] = useStorageState(
    langStorageKey,
    defaultLocale,
    memoryStorageDriver,
  );

  return { lang, setLang };
};
